import React, { useState, useEffect} from "react";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";
import axios from 'axios';
import { Navigate } from "react-router-dom";
import Select from "react-select";
 
const InvoiceCreate = ()=>{
    const [matravelpackage, setMatravelpackage ] = useState('');
     const [invoiceno, setInvoiceno ] = useState('');
     const [client, setClient ] = useState('');
     const [invoicedate, setInvoicedate ] = useState('');
     const [invoicetotal, setInvoicetotal ] = useState('');
     const [redirect, setRedirect] = useState(false);
          const [loading, setLoading] = useState(false);
     const [hasError, setHasError] = useState(false);
     const [errorMessage, setErrorMessage] = useState('');
     const [matravelpackageList, setMatravelpackageList] = useState([]);
     const [clientList, setClientList] = useState([]);

     const submit = async (e)=>{
         e.preventDefault();
         const {data} = await axios.post('invoice', {
            invoice_no:invoiceno,
            client_id:client,
            travel_package_id:matravelpackage,
            invoice_date:invoicedate,
            invoice_total:parseFloat(invoicetotal),
        });
        console.log(data);
        setRedirect(true);
     }
         
      useEffect(() => {
        const fetchMatravelPackages = async () => {
           setLoading(true);
           setHasError(false);
           setErrorMessage('');
     
           try {
             const { data } = await axios.get(`maTravelPackage?page=${1}`);
             setMatravelpackageList(data.data);
               //console.log(data.data);
           } catch (error) {
             if (error.response) {
               // The request was made and the server responded with a status code
               // that falls out of the range of 2xx
               if (error.response.status === 401) {
                 setErrorMessage("Unauthorized access.");
               } else if (error.response.status === 400) {
                 setErrorMessage("Bad request. Please check your input.");
               }
               else if (error.response.status === 500) {
                 setErrorMessage("Insufficient Permissions");
               }
               else {
                 setErrorMessage("An error occurred. Please try again later.");
               }
             } else if (error.request) {
               // The request was made but no response was received
               if (error.message === "Network Error") {
                 setErrorMessage("Failed to connect to the server. Please try again later.");
               } else {
                 setErrorMessage("No response received. Please try again later.");
               }
             } else {
               // Something happened in setting up the request that triggered an Error
               setErrorMessage("An error occurred. Please try again later.");
             }
             setHasError(true);
           } finally {
             setLoading(false);
           }
         };
     
         fetchMatravelPackages();

    }, []);



         useEffect(() => {
        const fetchClients = async () => {
           setLoading(true);
           setHasError(false);
           setErrorMessage('');
     
           try {
             const { data } = await axios.get(`client?page=${1}`);
             setClientList(data.data);
               //console.log(data.data);
           } catch (error) {
             if (error.response) {
               // The request was made and the server responded with a status code
               // that falls out of the range of 2xx
               if (error.response.status === 401) {
                 setErrorMessage("Unauthorized access.");
               } else if (error.response.status === 400) {
                 setErrorMessage("Bad request. Please check your input.");
               }
               else if (error.response.status === 500) {
                 setErrorMessage("Insufficient Permissions");
               }
               else {
                 setErrorMessage("An error occurred. Please try again later.");
               }
             } else if (error.request) {
               // The request was made but no response was received
               if (error.message === "Network Error") {
                 setErrorMessage("Failed to connect to the server. Please try again later.");
               } else {
                 setErrorMessage("No response received. Please try again later.");
               }
             } else {
               // Something happened in setting up the request that triggered an Error
               setErrorMessage("An error occurred. Please try again later.");
             }
             setHasError(true);
           } finally {
             setLoading(false);
           }
         };
      
         fetchClients();

    }, []);


    if(redirect){
        return <Navigate to={'/invoices'} />
    }
     return (
         <Wrapper pageTitle={"New Invoice"}>
            <InnerNav createLink={'/invoiceCreate'} listLink={'/invoices'} />
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >
                   
                   
                     <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Client </span>
                        

                        <Select
                            options={clientList.map((client) => ({
                                value: client.id,
                                label: `${client.name} ${client.name}`.trim(),
                            }))}
                            onChange={(selectedOption) =>
                            setClient(selectedOption.value)
                            }
                        />
                    </label>
                   
                   
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Invoice No </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Invoice No"
                        onChange = {e => setInvoiceno(e.target.value)} />
                    </label>

                  

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Invoice Date </span>
                        <input type="date"
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Invoice Date"
                        onChange = {e => setInvoicedate(e.target.value)} />
                    </label>

                     <label className="block text-sm mb-4">
                        <span className="text-gray-700 dark:text-gray-400">Travel Package</span>
                        <Select
                            options={matravelpackageList.map((travelPackage) => ({
                            value: travelPackage.id,
                            label: `${travelPackage.name} ${travelPackage.name}`.trim(),
                            }))}
                            onChange={(selectedOption) =>
                            setMatravelpackage(selectedOption.value)
                            }
                        />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Invoice Total </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Invoice Total"
                        onChange = {e => setInvoicetotal(e.target.value)} />
                    </label>

                    <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                        <button className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                        onClick={submit}
                        > <FiSave /> <span className="ml-3">Save</span> </button>
                        </label>
                    </div>
                </div>
             </form>
        </Wrapper>
     );
};
export default InvoiceCreate;